var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('HeaderPayment'),_c('HeroPayment'),_c('PaymentFeatureSection'),_c('PaymentStep'),_c('PaymentPricingWrapper'),_c('PaymentNewsletter'),_c('CarouselStartup'),_c('FooterMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }